import { backgroundColors } from '@components/layout/colors/background-colors.css'
import { brandColors } from '@components/layout/colors/brand-colors.css'
import { commonColors } from '@components/layout/colors/common-colors.css'
import {
  HostLandingPageAccentColors,
  LandingPageListingType,
} from '@page/BecomeAHostTemplate/types'

export const hostLandingThemeColorOptions: Record<
  LandingPageListingType,
  HostLandingPageAccentColors
> = {
  pool: {
    primary: brandColors.primaryBlue,
    primaryLight: backgroundColors.skyBlue,
    secondary: brandColors.darkBlue,
  },
  basketballCourt: {
    primary: brandColors.hoopsOrange,
    primaryLight: commonColors.bare,
    secondary: brandColors.hoopsOrange,
  },
  tennisCourt: {
    primary: brandColors.tennisGreen,
    primaryLight: commonColors.natureGreen,
    secondary: brandColors.tennisGreen,
  },
  pickleball: {
    primary: brandColors.darkBlue,
    primaryLight: backgroundColors.skyBlue,
    secondary: brandColors.darkBlue,
  },
  home: {
    primary: brandColors.primaryBlue,
    primaryLight: backgroundColors.skyBlue,
    secondary: brandColors.darkBlue,
  },
}
